import React from 'react';
import _ from "underscore";

import Container from "react-bootstrap/Container";

import config from "../../config";
import Nav from "react-bootstrap/Nav";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const MagazineMenu = () => {
    const article_1 = {
        url: `${config.host_rebag_shop}/collections/wishlist-worthy/`,
        title: "Wishlist-Worthy",
        image: `${config.MEDIA_URL}/img/gift-guide/wishlist-worthy-nav2.jpg`,
        cta_label: "Shop"
    }
    const article_2 = {
        url: `${config.host_rebag_shop}/collections/cant-go-wrong/`,
        title: "Can’t Go Wrong",
        image: `${config.MEDIA_URL}/img/gift-guide/cant-go-wrong-nav.jpg`,
        cta_label: "Shop"
    }

    return (
        <div className="top-nav">
            <Container>
                <Row>
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 2, offset: 0 }}>
                        <h4 className="top-nav__nav-title">The 2022 Gift Suite</h4>
                        <Nav className="top-nav__nav-list top-nav__gift-links">
                            {_.map(config.gift_collections, (collection, idx) => {
                                return (
                                    <Nav.Item
                                        key={idx}
                                        className={`top-nav__nav-list-item-secondary nav-link nav-top-link`}
                                        as="a"
                                        href={collection.url}
                                    >
                                        {collection.title}
                                    </Nav.Item>
                                );
                            })}
                        </Nav>
                    </Col>
                    <Col xl={3} lg={5}>
                        <MagazineArticle key="article-last" article={article_1} />
                    </Col>
                    <Col xl={3} lg={5}>
                        <MagazineArticle key="article-before-last" article={article_2} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const MagazineArticle = ({ article }) => {
    return (
        <div className="top-nav__article">
            <a href={article.url}>
                <div className="top-nav__article-img">
                    <img
                        alt={article.title}
                        src={article.header_vault_image || article.image}
                        title={article.title}
                    />
                </div>
                <div className="top-nav__article-text">
                    <h2 className="top-nav__gifts-title top-nav__article-title--caps">
                        {article.title}
                    </h2>
                    <div className="top-nav__gifts-cta">
                        {article.cta_label}
                    </div>
                </div>
            </a>
        </div>
    )
}

export default MagazineMenu;